export const pageTenantPermissions = {
  people: ['members:list'],
  storage: [
    'customers:retrieve',
    'galleries:overview',
    'subscriptions:retrieve',
    'galleries:list',
    'invoices:list', // just there as a way to hide the storage page for members
  ],
  credits: [
    'customers:retrieve',
    'galleries:overview',
    'subscriptions:retrieve',
    'galleries:list',
    'invoices:list', // just there as a way to hide the storage page for members
  ],
  branding: ['tenants:update', 'domains:list', 'domains:create'],
  rewards: ['referrals:list', 'referrals:delete'],
  billing: ['subscriptions:update'],
  pricing: ['subscriptions:update'],
  checkout: ['subscriptions:update'],
  presets: ['gallery-presets:create'],
  workspace: ['tenants:update', 'domains:list', 'domains:create'],
  watermarks: ['watermarks:create'],
  experiments: ['subscriptions:update'],
  tags: ['tags:create'],
};
